import React from 'react';
import { Header } from '../components/Header';
import { HeroSection } from '../components/HeroSection';
import { SocialProofBar } from '../components/SocialProofBar';
import { PainPointsSection } from '../components/PainPointsSection';
import { GallerySection } from '../components/GallerySection';
import { SneakPeekSection } from '../components/SneakPeekSection';
import { BonusBanner } from '../components/BonusBanner';
import { OfferSection } from '../components/OfferSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { FAQSection } from '../components/FAQSection';
import { Footer } from '../components/Footer';
import { PurchasePopup } from '../components/PurchasePopup';
export function LandingPage() {
  return <div className="min-h-screen font-sans text-dark bg-cream selection:bg-mint/30" data-id="element-280">
      <PurchasePopup data-id="element-281" />
      <Header data-id="element-282" />
      <main data-id="element-283">
        <HeroSection data-id="element-284" />
        <SocialProofBar data-id="element-285" />
        <PainPointsSection data-id="element-286" />
        <GallerySection data-id="element-287" />
        <SneakPeekSection data-id="element-288" />
        <BonusBanner data-id="element-289" />
        <OfferSection data-id="element-290" />
        <TestimonialsSection data-id="element-291" />
        <FAQSection data-id="element-292" />
      </main>
      <Footer data-id="element-293" />
    </div>;
}